import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'src/app/shared/services/account/account.services';
import { SnackbarComponent } from '../../shared/snackbar/snackbar.component';
import { SnackBarTheme } from '../../shared/models/snackbar-theme.enum';
import { TranslationConstants } from '../../shared/services/util/translation.constants';
import { emailValidator } from 'src/app/shared/validators/email.validator';
import * as Sentry from "@sentry/angular";
@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['../styles/card.style.component.scss']
})
export class ForgotComponent implements OnInit {

    public loading: boolean;
    public email: string;
    public errorHint: boolean;
    public isReseting: boolean = false;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly location: Location,
        private readonly accountService: AccountService,
        private readonly snackbarComponent: SnackbarComponent,
        private readonly translationConstants: TranslationConstants
    ) { }

    public ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
                this.isReseting = params?.isReset;
            }
        );
    }

    public send(): void {
        Sentry.setUser({ email: this.email });
        this.loading = true;
            this.accountService.sendCode({email: this.email}).subscribe(success => {
                this.snackbarComponent.openSnackBar(this.translationConstants.translate('account.forgot.success'), SnackBarTheme.success, 4000);
            this.router.navigate(['account/reset']);
        }, error => {
            this.errorHint = true;
            this.snackbarComponent.openSnackBar(this.translationConstants.translate(`account.forgot.error.${error.code}`), SnackBarTheme.error, 4000);
        }).add(() => {
            this.loading = false;
        });
    }

    public verifyEmail(): void {
        this.errorHint = !emailValidator(this.email);
    }

    public cancel(): void {
       this.location.back();
    }
}
